import { ApolloClient, ApolloProvider } from '@apollo/client'
import { Loader } from 'lucide-react'
import { Suspense, use } from 'react'

const GraphQLProviderData = ({
  pApolloClient,
  children,
}: {
  pApolloClient: Promise<ApolloClient<any>>
  children: React.ReactNode
}) => {
  const client = use(pApolloClient)
  return <ApolloProvider client={client}>{children}</ApolloProvider>
}

export const GraphQLProvider = ({
  pApolloClient,
  children,
}: {
  pApolloClient: Promise<ApolloClient<any>>
  children: React.ReactNode
}) => {
  return (
    <Suspense
      fallback={
        <div className="absolute inset-0 flex items-center justify-center">
          <Loader className="text-orange-600 animate-spin size-5" />
        </div>
      }
    >
      <GraphQLProviderData pApolloClient={pApolloClient}>
        {children}
      </GraphQLProviderData>
    </Suspense>
  )
}
